import React from 'react';
import UnitsPage from './UnitsPage';

const AutoTanquesPage = () => {
  return <UnitsPage tipoUnidad="auto tanque" title="Auto Tanques" />;
};

export default AutoTanquesPage;
